import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useMsal } from "@azure/msal-react";
import { useLocalStorage } from "../utils/LocalStorageHook";
import { getAuth } from "../utils/GetAuth";
import requestMissingContexts, { determineConfig } from "../utils/GetContext";

export default function TitlebarMenu() {
  const { instance, accounts, inProgress } = useMsal();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [salesOrgs, setSalesOrgs] = useState<any[]>([]);
  const [soSetting, setSoSetting] = useLocalStorage("SETTINGS.salesOrg", "");
  const [dbSystemInd, setDbSystemInd] = useLocalStorage("SETTINGS.dbSystemInd", "?");
  const [codes, setCodes] = React.useState<any>();

  const handleSOClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleSOClose = (salesOrg: string) => {
    if (typeof salesOrg === "string" && salesOrg && soSetting !== salesOrg) {
      setSoSetting(salesOrg);
      window.location.reload();
    }
    setAnchorEl(null);
  };

  useEffect(() => {
    if (salesOrgs.length > 0) return;

    getAuth(instance, accounts).then((v) => {
      setSalesOrgs((v?.salesOrgs)||[]);
      setDbSystemInd((v?.dbSystemInd)||'?');
      requestMissingContexts(["SALESORGS"]).then((v) => {
        setCodes(v);
      })
    });
  }, [salesOrgs.length]);

  if (!salesOrgs || salesOrgs.length < 1) return <div />;
  if (!soSetting && !!salesOrgs) setSoSetting(salesOrgs[0]);

  return (
    <div>
      <Button
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleSOClick}
        color="inherit"
      >
        {soSetting || "Sales Organizations"}
      </Button>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleSOClose}
      >
        {salesOrgs.map((s) => (
          <MenuItem key={s} onClick={() => handleSOClose(s)}>{`${s}: ${determineConfig(codes, "SALESORGS",s)}`}</MenuItem>
        ))}
      </Menu>
    </div>
  );
}
